import { render, staticRenderFns } from "./SKUGenerator.vue?vue&type=template&id=0faf1910&"
import script from "./SKUGenerator.vue?vue&type=script&lang=js&"
export * from "./SKUGenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports